export { segmentEvent } from "./segmentEvent";
export {
  SegmentEventLocations,
  SegmentEventNames,
  PERSONALIZATION_TAB_SEGMENT_EVENT_MAP,
  VIEW_STATE_TO_SEGMENT_LOCATION,
} from "./constants";
